import { createFileRoute, useSearch } from '@tanstack/react-router';
import { EmailVerificationPage } from '@/components/auth/EmailVerificationPage';

export interface EmailVerificationSearch {
  token?: string;
}

export const Route = createFileRoute('/_public/auth/verify-email')({
  validateSearch: (search: Record<string, unknown>): EmailVerificationSearch => ({
    token: typeof search.token === 'string' ? search.token : undefined,
  }),
  component: EmailVerificationRoute,
});

function EmailVerificationRoute(): JSX.Element {
  const { token } = useSearch({ from: '/_public/auth/verify-email' });
  return <EmailVerificationPage token={token} />;
}
